import { useRef } from "react";
import Select from "./select";
import useStore from "../hooks/useStore";
import { useFetchAbsenceTrackingCategories } from "../hooks/fetch/useFetchAbsenceTrackingCategories";

const AbsenceTypePicker = ({ name, value, onChange, onBlur, disabled }) => {
  const account = useStore((state) => state.clientRef);
  const { data: categories = [] } = useFetchAbsenceTrackingCategories({
    account,
  });
  const id = useRef(
    `absence-type-${Math.random().toString(36).slice(2)}`,
  ).current;
  const options = categories.map(({ ref, label, colour }) => ({
    value: ref,
    label,
    colour,
  }));
  const values = [
    {
      label: "Holiday",
      value: "holiday",
    },
    {
      label: "Sickness",
      value: "sickness",
    },
    {
      label: "Family",
      value: "family",
    },
    {
      label: "Other",
      value: "other",
    },
  ];
  return (
    <div>
      <div className="absence-type-picker">
        {values.map((type) => (
          <label key={type.value} htmlFor={`${id}-${type.value}`}>
            <span className="button-link radio" data-disabled={disabled}>
              <input
                type="radio"
                id={`${id}-${type.value}`}
                name={`${name}-${id}`}
                value={type.value}
                checked={type.value === value}
                disabled={disabled}
                onChange={() => onChange(type.value)}
                onBlur={onBlur}
              />
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <circle
                  cx="12"
                  cy="12"
                  r="5"
                  className="radio-button"
                  fill="currentColor"
                />
              </svg>
            </span>
            {type.label}
          </label>
        ))}
      </div>
      {options.length > 0 && (
        <div className="absence-type-picker--more">
          <label htmlFor={`${id}-more`}>More:</label>
          <Select
            inputId={`${id}-more`}
            className="select"
            options={options}
            value={options.find((option) => option.value === value) || null}
            onChange={(option) => onChange(option.value)}
            onBlur={onBlur}
            isDisabled={disabled}
            isClearable={false}
            placeholder="Choose a tracking category"
            menuPlacement="auto"
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 60 }) }}
            formatOptionLabel={(option) => (
              <span className="absence-type-picker--option">
                <span
                  className="absence-type-picker--dot"
                  style={{ backgroundColor: option.colour }}
                  aria-hidden="true"
                />
                {option.label}
              </span>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default AbsenceTypePicker;
